<template>
  <section class="section_standards">
    <div class="container_text_standards">
      <div class="box_sub_text_category">
        <h2 class="title_category">
          <span class="color_orange"> НАШИ СТАНДАРТЫ КАЧЕСТВА</span><br />

          ПОЧЕМУ МЫ УВЕРЕНЫ В КАЧЕСТВЕ НАШЕЙ МЕБЕЛИ
        </h2>
      </div>
      <div class="box_sub_text_category">
        <p class="sub_text_category">
          Только надёжные материалы, строгий контроль на каждом этапе и сборка,
          выполненная опытными мастерами <br />— вот почему наша мебель служит
          годами.
        </p>
      </div>
    </div>
    <div class="container_element_standart">
      <div class="contante_work">
        <p class="title_contante_work">
          Качественные материалы
          <br />
          <span class="color_orange">и фурнитура</span>
        </p>
        <p class="small_text_works">
          Мы работаем с такими материалами, как AGT, ALVIK, МДФ В ЭМАЛИ , ЛДСП
          EGGER. Используем фурнитуру премиум-качества Blum и Hettich.
        </p>
        <p class="pseudo_text">01</p>
      </div>
      <div class="contante_work">
        <p class="title_contante_work">
          Индивидуальный
          <br />
          <span class="color_orange">подход</span>
        </p>
        <p class="small_text_works">
          Адаптируем любую мебель под ваши размеры и особенности вашего
          помещения. Изготавливаем мебель по вашей картинке.
        </p>
        <p class="pseudo_text">02</p>
      </div>
      <div class="contante_work">
        <p class="title_contante_work">
          Контроль
          <br />
          <span class="color_orange">качества</span>
        </p>
        <p class="small_text_works">
          Мы контролируем каждый этап изготовления, транспортировки и установки
          вашей мебели .
        </p>
        <p class="pseudo_text">03</p>
      </div>
      <div class="contante_work">
        <p class="title_contante_work">
          Гарантия 
          <br />
          <span class="color_orange">на изделие</span>
        </p>
        <p class="small_text_works">
          Мы предоставляем гарантию 1 год на все наши изделия.
        </p>
        <p class="pseudo_text">04</p>
      </div>
    </div>
  </section>
</template>
<style scoped>
.section_standards {
  display: flex;
  padding: 0px 8rem;
  padding-bottom: 7rem;
}
.container_text_standards {
  display: flex;
  flex-direction: column;
  gap: 6rem;
  padding-top: 2.5rem;
}
.title_category {
  font-family: Roboto;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.9rem;
  letter-spacing: -1.5%;
  text-align: left;
  color: rgb(255, 255, 255);
}
.box_sub_text_category {
  width: 26.6rem;
}
.sub_text_category {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.4rem;
  letter-spacing: 0%;
  text-align: left;
}
.contante_work {
  position: relative;
  display: flex;
  width: 12.8rem;
  height: fit-content;
  gap: 1rem;
  align-items: flex-start;
  flex-direction: column;
  padding-top: 2.5rem;
}
.title_contante_work {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.4rem;
  letter-spacing: 0%;
  text-align: left;
}
.pseudo_text {
  position: absolute;
  right: 0px;
  top: 0px;
  color: rgb(245, 160, 62);
  font-family: Roboto;
  font-size: 6.4rem;
  font-weight: 700;
  line-height: 7.5rem;
  letter-spacing: 0%;
  text-align: left;
  opacity: 0.15;
}
.small_text_works {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;

  width: 12.8rem;
}
.container_element_standart {
  width: fit-content;
  display: flex;
  flex-wrap: wrap;
  gap: 13rem;
  row-gap: 2.25rem;
  justify-content: flex-end;
}
@media (max-width: 767px) {
  .section_standards {
    padding: 1rem 2.4rem;
    flex-direction: column;
    gap: 1rem;
  }
  .box_sub_text_category {
    width: 100%;
  }
  .container_text_standards {
    gap: 1.5rem;
  }
  .contante_work {
    width: 16.5rem;
    padding-top: 4rem;
  }
  .container_element_standart {
    flex-direction: column;
    width: 100%;
    align-items: flex-end;
    gap: 0rem;
  }
  .title_contante_work {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.14rem;
  }
  .title_category {
    font-size: 1.43rem;
    font-weight: 700;
    line-height: 1.64rem;
  }
  .sub_text_category {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.14rem;
  }
  .pseudo_text {
    font-size: 6.86rem;
    font-weight: 700;
    line-height: 8.07rem;
  }
}
</style>
